"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcomSorterView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const app_2 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const __1 = require("../..");
const FilterSort_1 = require("../../lib/common/FilterSort");
const StyledTitle = (0, app_1.styled)(FilterSort_1.Title) `
  text-transform: uppercase;
`;
function Input({ sortDefinitions, defaultValue, setValue, }) {
    const { pathname, params } = (0, __1.useSearchMeta)();
    const { push } = (0, app_1.useRouter)();
    (0, react_1.useEffect)(() => {
        setValue('sort', defaultValue !== null && defaultValue !== void 0 ? defaultValue : '');
    }, [defaultValue, setValue]);
    return ((0, jsx_runtime_1.jsx)(ui_1.SelectInput, Object.assign({ name: "sort", label: "Sortuj", defaultValue: defaultValue, optional: true, onChange: (value) => {
            const [sort, sortOrder] = value.split('-');
            if (sort !== params.sort && sortOrder !== params.sortOrder) {
                void push(new app_2.Href(pathname, Object.assign(Object.assign({}, params), { sort, sortOrder })), {
                    shallow: true,
                });
            }
            return value;
        } }, { children: sortDefinitions.map((sorter) => ((0, jsx_runtime_1.jsx)(ui_1.SelectInput.Option, Object.assign({ value: `${sorter.by}-${sorter.order}` }, { children: sorter.title }), sorter.title))) })));
}
function EcomSorterView({ sortDefinitions, }) {
    const { t } = (0, app_1.useTranslation)();
    const { pathname, category, params } = (0, __1.useSearchMeta)();
    const baseSorters = [
        {
            title: t('label.sortNovelties'),
            by: 'createdAt',
            order: 'desc',
        },
        {
            title: t('label.sortNameAsc'),
            by: 'title',
            order: 'asc',
        },
        {
            title: t('label.sortNameDesc'),
            by: 'title',
            order: 'desc',
        },
        {
            title: t('store.label.sortPriceAsc'),
            by: 'priceIndex',
            order: 'asc',
        },
        {
            title: t('store.label.sortPriceDesc'),
            by: 'priceIndex',
            order: 'desc',
        },
    ];
    const sorters = [...baseSorters, ...(sortDefinitions !== null && sortDefinitions !== void 0 ? sortDefinitions : [])];
    return ((0, jsx_runtime_1.jsxs)(FilterSort_1.Wrap, { children: [(0, jsx_runtime_1.jsxs)(FilterSort_1.List, { children: [(0, jsx_runtime_1.jsx)(StyledTitle, { children: t.colon('label.sortBy') }), (0, jsx_runtime_1.jsx)(FilterSort_1.Ul, { children: sorters.map(({ title, by, order }) => ((0, jsx_runtime_1.jsx)(FilterSort_1.Li, Object.assign({ "$active": (params === null || params === void 0 ? void 0 : params.sort) === by && (params === null || params === void 0 ? void 0 : params.sortOrder) === order }, { children: (0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ shallow: true, href: new app_2.Href(pathname, Object.assign(Object.assign({}, params), { sort: by, sortOrder: order, category })) }, { children: title })) }), title))) })] }), (0, jsx_runtime_1.jsx)(ui_1.Form, { children: (0, jsx_runtime_1.jsx)(FilterSort_1.Selector, { children: (0, jsx_runtime_1.jsx)(ui_1.FormContext, { children: ({ setValue }) => {
                            var _a;
                            return ((0, jsx_runtime_1.jsx)(Input, { setValue: setValue, defaultValue: params.sort && `${params.sort}-${(_a = params.sortOrder) !== null && _a !== void 0 ? _a : ''}`, sortDefinitions: sorters }));
                        } }) }) })] }));
}
exports.EcomSorterView = EcomSorterView;
